module.exports = __webpack_public_path__ + "img/47.9b74f184.jpg";